import Vue from 'vue'
import Router from 'vue-router'
import config from '@assets/config.json'
import store from '../store/store'
import { AudienceRouter } from './router-audience' // 观众路由
import { AudienceEnRouter } from './router-audienceEn' // 观众路由 - 英文
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location);
//   // .catch(err => err)
// }

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: 'home', name: 'home' },
    ...AudienceRouter,
    ...AudienceEnRouter
  ]
})

// // 路由守卫  2025-02-26之前
// router.beforeEach((to, form, next) => {
//   if (to.meta && to.meta.requireAuth === false) {
//     // 判断该路由是否需要登录权限 false 为不需要登录
//     next()
//   } else {
//     // if (store.state.login) {
//     //   next();
//     // } else {
//     //   next({ path: '/exhibition/login/alogin' });
//     // }
//   }
//   next()
// })

// 这样会导致报错   无限循环   2025-02-26之前
// router.beforeEach((to, form, next) => {
//   const timestamp = Date.now()
//   const queryParams = { ...to.query, t: timestamp }
//   if (!to.query.t || to.query.t !== timestamp.toString()) {
//     next({ path: to.path, query: queryParams })
//   } else {
//     next()
//   }
// })

// 优化后的  2025-02-26之后的
router.beforeEach((to, from, next) => {
    console.log(to, 'to');
    const timestamp = Date.now();

    // Check if the current route already has the 't' query parameter
    if (!to.query.t) {
        const queryParams = { ...to.query, t: timestamp }; // Merge existing query params with the new timestamp
        next({
            path: to.path,
            query: queryParams
        });
    } else {
        // If 't' query already exists, simply proceed to the next route without modification
        next();
    }
});


// 百度统计
router.afterEach((to, from, next) => {
  if (to.path === '/home') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
    // console.log("首页：",to);
    var _hmt = _hmt || []
    ;(function () {
      //每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') &&
        document.getElementById('baidu_tj').remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?4777fee6a1de3645458457ad57176291'
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }
  if (to.path === '/ex-list') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
    var _hmt = _hmt || []
    ;(function () {
      //每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') &&
        document.getElementById('baidu_tj').remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?d164e40bb45eb339a0c547623151758c'
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
    // console.log("产品/企业：",to);
  }
  if (to.path === '/chance') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
    var _hmt = _hmt || []
    ;(function () {
      //每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') &&
        document.getElementById('baidu_tj').remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?fa6badadb2d8903629cbb01d57e1ea17'
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
    // console.log("供需：",to);
  }
  if (to.path === '/news') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/contact') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/meeting') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/meeting-live') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/about') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/ex-list') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/pro-list') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/act-list') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/chance-type') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/news-details') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/chance-detail') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/activity-details') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/pro-details') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
  if (to.path === '/ex-details/') {
    window.location.href = `${config.PCUrl}/exhibitorlist?cid=18`
  }
})




export default router
